// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"9f235919","153":"f4e6777c"}[chunkId] + ".chunk.js";
};